import React from "react";
import axios from "axios";
import AttendeeView from "./components/AttendeeView";
import SpeakerView from "./components/SpeakerView";
import LandingView from "./components/LandingView";
import Roles from "./constants/userRoleEnum";
import MeetingIDInput from "./components/MeetingIDInput";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userRole: Roles.NONE,
      msg: "Getting the message",
    };
    var handleRoleSelection = this.handleRoleSelection.bind(this);
  }

  handleRoleSelection(role) {
    this.setState({
      userRole: role,
    });
  }

  componentDidMount() {
    let messagePromise = axios.get("http://144.126.212.184:8000");
    messagePromise.then(
      (res) => {
        this.setState({
          msg: res.data,
        });
      },
      (error) => {
        console.log("got error");
        console.log(error);
      }
    );

    let postPromise = axios.post("http://144.126.212.184:8000/testPost", {
      msg: "test post",
    });
    postPromise.then(
      (res) => {
        console.log(res);
      },
      (error) => {
        console.log("got error");
        console.log(error);
      }
    );
  }

  render() {
    var handleRoleSelection = this.handleRoleSelection;
    return (
      <div>
        <div className="title">Vibe Check</div>
        {/* <h3>Testing vibecheck</h3>
        <p>Message received from server: {this.state.msg}</p> */}
        {this.state.userRole === Roles.NONE ? (
          <LandingView handleRoleSelection={handleRoleSelection.bind(this)} />
        ) : this.state.userRole === Roles.SPEAKER ? (
          <SpeakerView />
        ) : (
          <MeetingIDInput/>
        )}
        {/* <p>The user's role is {this.state.userRole}</p> */}
        
      </div>
    );
  }
}

export default App;
